.main {
  padding-top: calc(var(--header-height) + 1rem);
}
